import PropTypes from 'prop-types';
import React from 'react';
import { Award, Pencil } from 'lucide-react';
import { formatYearRange } from 'helpers/portfolioLayout';
import styles from '../../CareerEntries.module.scss';

const QualificationDetails = ({ qualification, onEdit, isOwn, user }) => (
  <div className={styles.entry}>
    <span
      className={`${styles.iconTile} ${styles.iconTileAward}`}
      aria-hidden="true"
    >
      <Award size={18} strokeWidth={2} />
    </span>
    <div className={styles.body}>
      <div className={styles.titleRow}>
        <span className={styles.title}>{qualification.qualification}</span>
        <span className={styles.dates}>
          {formatYearRange(qualification.started_at, qualification.ended_at)}
        </span>
      </div>
      {qualification.content && (
        <p className={styles.description}>{qualification.content}</p>
      )}
    </div>
    {user && isOwn && (
      <button
        type="button"
        className={styles.editEntryBtn}
        onClick={onEdit}
        aria-label={`Edit ${qualification.qualification || 'certification'}`}
      >
        <Pencil size={15} strokeWidth={2} aria-hidden="true" />
      </button>
    )}
  </div>
);

QualificationDetails.propTypes = {
  qualification: PropTypes.object,
  onEdit: PropTypes.func,
  isOwn: PropTypes.bool,
  user: PropTypes.object,
};

export default QualificationDetails;
